<mat-card class="dashboard-card">
  <mat-toolbar color="primary" *ngIf="patient">
    <div>
      <img src="assets/assist-logo.png" (click)="goHome()" class="client-logo" alt="Tensor Logo">
    </div>
    <span class="toolbar-title" (click)="goHome()">TensorLinks</span>

    <span class="spacer"></span>

    <!-- Desktop icons (hidden on mobile) -->
    <button mat-icon-button class="toolbar-icon desktop-only" [class.active]="isHomeActive()" (click)="goHome()" matTooltip="Home" matTooltipPosition="below"
      matTooltipClass="custom-tooltip">
      <mat-icon>home</mat-icon>
    </button>

    <button mat-icon-button class="toolbar-icon desktop-only" [class.active]="isProfileActive()" (click)="navigateToProfile()"
      matTooltip="Insurance" matTooltipPosition="below" matTooltipClass="custom-tooltip">
      <mat-icon>edit</mat-icon>
    </button>

    <!-- <button mat-icon-button class="toolbar-icon desktop-only" [class.active]="isFormsActive()" (click)="navigateToForms()"
      matTooltip="Registration Forms" matTooltipPosition="below" matTooltipClass="custom-tooltip">
      <mat-icon>description</mat-icon>
    </button> -->

    <button mat-icon-button class="toolbar-icon desktop-only" [class.active]="isDocumentsActive()" (click)="navigateToDocuments()"
      matTooltip="Documents" matTooltipPosition="below" matTooltipClass="custom-tooltip">
      <mat-icon>folder_open</mat-icon>
    </button>

    <!-- <button mat-icon-button class="toolbar-icon desktop-only" [class.active]="isNotificationsActive()" (click)="navigateToNotifications()" matTooltip="Notifications"
      matTooltipPosition="below" matTooltipClass="custom-tooltip">
      <mat-icon>notifications</mat-icon>
    </button> -->

    <app-theme-switcher class="desktop-only"></app-theme-switcher>

    <!-- Profile menu button -->
    <button mat-icon-button [matMenuTriggerFor]="profileMenu" class="toolbar-icon" matTooltip="Menu"
      matTooltipPosition="below" matTooltipClass="custom-tooltip">
      <mat-icon>person</mat-icon>
    </button>

    <!-- Combined profile menu - shows different content based on screen size -->
    <mat-menu #profileMenu="matMenu" class="profile-menu">
      <!-- Desktop-only: Just profile component -->
      <div class="desktop-menu-content">
        <app-profile [patient]="patient"></app-profile>
      </div>

      <!-- Mobile-only: Profile + navigation -->
      <div class="mobile-menu-content">
        <!-- Profile component at top -->
        <div class="mobile-profile-header" (click)="$event.stopPropagation()">
          <app-profile [patient]="patient"></app-profile>
        </div>

        <mat-divider></mat-divider>

        <!-- Navigation menu items -->
        <button mat-menu-item [class.active]="isHomeActive()" (click)="goHome()">
          <mat-icon>home</mat-icon>
          <span>Home</span>
        </button>

        <button mat-menu-item [class.active]="isProfileActive()" (click)="navigateToProfile()">
          <mat-icon>edit</mat-icon>
          <span>Edit Profile</span>
        </button>

        <!-- <button mat-menu-item [class.active]="isFormsActive()" (click)="navigateToForms()">
          <mat-icon>description</mat-icon>
          <span>Forms</span>
        </button> -->

        <button mat-menu-item [class.active]="isDocumentsActive()" (click)="navigateToDocuments()">
          <mat-icon>folder_open</mat-icon>
          <span>Documents</span>
        </button>

        <!-- <button mat-menu-item [class.active]="isNotificationsActive()" (click)="navigateToNotifications()">
          <mat-icon>notifications</mat-icon>
          <span>Notifications</span>
        </button> -->

        <mat-divider></mat-divider>

        <!-- Theme switcher in menu -->
        <div class="mobile-theme-switcher" (click)="$event.stopPropagation()">
          <app-theme-switcher></app-theme-switcher>
        </div>
      </div>
    </mat-menu>

    <!-- Close button - only shown when embedded in iframe -->
    <button
      *ngIf="isEmbedded"
      mat-icon-button
      (click)="closeEmbeddedPortal()"
      class="toolbar-icon close-button"
      matTooltip="Close Portal"
      matTooltipPosition="below"
      matTooltipClass="custom-tooltip">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <div *ngIf="showSearch" class="search-form-container">
    <form [formGroup]="searchForm" class="search-form">
      <mat-form-field appearance="outline">
        <mat-label>Search Forms</mat-label>
        <input matInput formControlName="search" placeholder="Enter form name">
        <button mat-icon-button matSuffix>
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </form>
  </div>
  <div class="container-spinner" *ngIf="loading">
    <mat-spinner [diameter]="50" color="primary"></mat-spinner>
  </div>
  <router-outlet></router-outlet>
</mat-card>

<!-- Minimal forms reminder - left corner -->
<div class="forms-reminder-minimal" *ngIf="showFormsReminder && pendingForms.length > 0">
  <div class="reminder-badge" (click)="toggleReminderPopup()">
    <mat-icon class="reminder-icon">assignment_late</mat-icon>
    <span class="reminder-count">{{ pendingForms.length }}</span>
  </div>
  <div class="reminder-popup" [class.show]="showReminderPopup">
    <div class="popup-header">
      <span>Complete Required Forms</span>
      <mat-icon class="close-icon" (click)="toggleReminderPopup()">close</mat-icon>
    </div>
    <div class="popup-items">
      <div class="popup-item" *ngIf="pendingForms.includes('registration')" 
           (click)="navigateToPendingForm('registration')">
        <mat-icon>person_add</mat-icon>
        <span>New Patient Registration</span>
      </div>
      <div class="popup-item" *ngIf="pendingForms.includes('consent')" 
           (click)="navigateToPendingForm('consent')">
        <mat-icon>assignment</mat-icon>
        <span>Consent Form</span>
      </div>
    </div>
  </div>
</div>

<!-- <tensor-web-assistant
  [tenantId]="tenantId"
  [useWebSocket]="'false'"
  [assistantType]="'text-assistant'">
</tensor-web-assistant> -->